import { useAuth } from '@/lib/auth/auth';
import type { MeMembershipsResult } from '@/lib/api/apiTypes';
import { setPostHogFeatureFlagTraits } from '@/lib/analytics/posthog';
import { useWorkspaceCapability } from '@/features/workspaces/useWorkspaceCapability';
import { useQuery } from '@tanstack/react-query';
import { Platform } from 'react-native';
import * as React from 'react';

export const orgMembershipKeys = {
  all: ['org-memberships'] as const,
};

export function useOrgMemberships(enabled = true) {
  const session = useAuth((state) => state.session);
  const request = useAuth((state) => state.request);
  const { currentVersion, supportsOrgWorkspace } = useWorkspaceCapability();

  const query = useQuery({
    queryKey: orgMembershipKeys.all,
    enabled: Boolean(session) && enabled && supportsOrgWorkspace,
    queryFn: () => request<MeMembershipsResult>('/me/memberships'),
  });

  React.useEffect(() => {
    if (!query.data) {
      return;
    }

    const orgMembershipCount = query.data.memberships.length;
    setPostHogFeatureFlagTraits({
      appVersion: currentVersion,
      hasBusinessContext: orgMembershipCount > 0,
      orgMembershipCount,
      platform: Platform.OS,
    });
  }, [currentVersion, query.data]);

  return query;
}
